const TextStyling = ({
  text = '',
  ctaType = '',
  stylings = [],
  url = '',
  id = '',
  fsHide = false,
}: {
  text?: string;
  ctaType?: string;
  stylings?: Array<string>;
  url?: string;
  id?: string;
  fsHide?: boolean;
} = {}) => ({
  text: String(text),
  ctaType: String(ctaType),
  stylings: stylings.map((styling) => String(styling)),
  url: String(url),
  id: String(id),
  fsHide: Boolean(fsHide),
});

export type TextStylingProps = ReturnType<typeof TextStyling>;

export default TextStyling;
